import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation AdyenSessionsMutation($input: AdyenSessionsInput!) {
    adyenSessions(input: $input) {
      id,
      sessionData
    }
  }
`;

function commit(environment, orderId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.adyenSessions);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
